export default __webpack_public_path__ + "static/media/HeroHeaderiPhoneSE.51c64f83.webp";